import { render, staticRenderFns } from "./SubmitRes.vue?vue&type=template&id=3c9555a5&scoped=true"
import script from "./SubmitRes.vue?vue&type=script&lang=js"
export * from "./SubmitRes.vue?vue&type=script&lang=js"
import style0 from "./SubmitRes.vue?vue&type=style&index=0&id=3c9555a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9555a5",
  null
  
)

export default component.exports